import { AUTH_STORAGE_KEYS } from '@cokitchen/cokitchen-auth';
import { CoKitchenType } from 'models/cokitchen.model';
import {
  ENUM_MEAL_STATUS,
  ENUM_PAYMENT_STATUS,
  ENUM_REQUEST_STATUS,
  ENUM_RETURNS_STATUS,
  ENUM_UNIT
} from 'models/common.model';
import { ENUM_PROCUREMENT_STATUS } from 'models/procurement.model';
import { StoreType } from 'models/store.model';
import { ENUM_TRANSFER_STATUS, TransferRequestType } from 'models/transfer-request.model';

export const ROUTE_KEYS = {
  LOGIN: '/login',
  RESET_PASSWORD: '/reset-password/:token',
  EDIT_PROFILE: 'edit-profile'
};

export const COKITCHEN_ID = '85c7d173-56ed-44c8-8335-ef0eecabf454';

export const MAIN_STORE_ROUTE_KEYS = {
  // INVENTORY
  DASHBOARD: '',
  INVENTORY_STOCK: '/main-store/inventory/stock',
  INVENTORY_STORE_ITEMS: '/main-store/inventory/store-items',
  STOCK_PREP_TEAM: '/kitchen/prep-team-stock',
  STOCK_BRAND_CHEF_TEAM: '/kitchen/brand-chef-stock',

  INVENTORY_REQUESTS: 'request',
  INVENTORY_REQUESTS_PREVIEW: 'request/preview',
  INVENTORY_STOCK_BULK_EDIT: 'bulk-edit/:stock',
  INVENTORY_STOCK_EDIT: 'edit/:stock_id',
  INVENTORY_STORE_ITEMS_EDIT: 'edit/:id',
  INVENTORY_STORE_ITEMS_ADD: 'add',
  INVENTORY_STORE_ITEMS_ADD_PREVIEW: 'add/preview',
  INVENTORY_STORE_ITEMS_BULK_EDIT: 'bulk-edit',
  VERIFY_EMAIL: '/verify-mail/:token',
  ITEM_REQUESTS: '/main-store/requests/item-requests',
  MANAGE_ITEM_REQUESTS_DETAILS: ':id',
  REVIEW_ITEM_REQUESTS_DETAILS: 'review/:id',

  EXCESS_RETURNS: '/main-store/requests/excess-returns',
  EXCESS_RETURNS_DETAILS: ':id',

  // procurement
  PROCUREMENT: '/main-store/procurement',
  NEW_PROCUREMENT: 'new',
  PROCUREMENT_LIST: 'list',
  PROCUREMENT_TEST: 'test',
  PROCUREMENT_UPDATE: 'update/:id',
  PROCUREMENT_DETAILS_UPDATE: 'update-details/:id',
  PROCUREMENT_UPDATE_REJECTED: 'update-rejected/:id',
  PROCUREMENT_COMPLETED: 'completed/:id',

  WASTE_REPORT: '/main-store/waste-report',

  // transfer
  TRANSFER: '/main-store/transfer',
  KITCHEN_TRANSFER: '/kitchen/transfer',

  // vendors
  VENDORS: '/main-store/vendors',
  VENDOR_PROFILE: ':id',
  ADD_VENDOR: 'add-vendor',
  EDIT_VENDOR_DETAILS: 'edit-vendor',
  EDIT_VENDOR_STORE_ITEMS: 'edit-vendor-store-items',
  // Trash
  TRASH: '/main-store/trash',
  // brand chefs
  MANAGE_MEALS: '/main-store/brand-chefs/manage-meals',
  ADD_MANAGE_MEALS: 'new',
  EDIT_MANAGE_MEALS: 'update/:id',
  UPDATE_MANAGE_MEALS: 'update',
  REQUEST_MANAGE_MEALS: 'request',
  BRAND_CHEF_REQUEST_REPORT: 'production-report/:id',
  COMPLETE_BRAND_CHEF_REQUEST: 'complete/:id',

  // 'Manage requests
  MANAGE_REQUESTS: '/main-store/brand-chefs/manage-requests',
  EDIT_REQUEST: 'edit',
  REVIEW_REQUEST: ':id/review',
  MANAGE_REQUESTS_REPORT: 'report',

  // 'Ingredient list
  INGREDIENT_LIST: '/main-store/pricing/ingredient-list',

  // 'Excel-meal configuration
  EXCEL_MEAL_CONFIGURATION: '/main-store/pricing/excel-meal/configuration',
  EXCEL_PREP_CONFIGURATION: '/main-store/pricing/excel-prep/configuration',
  ADD_MEALS_CONFIGURATION: 'new',
  EDIT_MEALS_CONFIGURATION: 'update',
  REQUEST_MEALS_CONFIGURATION: 'request',

  // 'Excel-meal pricing
  EXCEL_MEAL_PRICING: '/main-store/pricing/excel-meal/pricing',
  UPDATE_MEALS_PRICING: 'update',

  // 'App-meal meals
  APP_MEAL_MEALS: '/main-store/pricing/app-meal/meals',
  // 'App-meal addons
  APP_MEAL_ADDONS: '/main-store/pricing/app-meal/addons',
  // Base meals
  BASE_MEALS: '/main-store/pricing/base-meals',
  UPDATE_BASE_MEALS: 'update',

  // COST_SETTINGS
  COST_SETTINGS: '/main-store/pricing/cost-setting',

  // Payment tracker
  PAYMNET_TRACKER: '/main-store/payment-tracker',
  PAYMNET_TRACKER_UPDATE: 'update/:id',

  KITCHEN_INVENTORY_STOCK: '/kitchen/inventory/stock',
  KITCHEN_INVENTORY_STORE_ITEMS: '/kitchen/inventory/store-items',
  KITCHEN_INVENTORY_REQUESTS: 'request',

  KITCHEN_INVENTORY_REQUESTS_PREVIEW: 'request/preview',
  KITCHEN_INVENTORY_STOCK_BULK_EDIT: 'bulk-edit/:stock',
  KITCHEN_INVENTORY_STOCK_EDIT: 'edit/:stock_id',
  KITCHEN_INVENTORY_STOCK_EXCESS_RETURNS: 'excess-returns',
  KITCHEN_INVENTORY_STORE_ITEMS_EDIT: 'edit/:id',
  KITCHEN_INVENTORY_STORE_ITEMS_BULK_EDIT: 'bulk-edit',
  KITCHEN_INVENTORY_STORE_ITEMS_ADD: 'add',
  KITCHEN_INVENTORY_STORE_ITEMS_ADD_PREVIEW: 'add/preview',
  KITCHEN_MANAGE_ITEM_REQUESTS: '/kitchen/requests/item-requests',
  KITCHEN_MANAGE_ITEM_REQUESTS_DETAILS: '/kitchen/requests/item-requests/:id',
  KITCHEN_MANAGE_ITEM_SENT_DETAILS: '/kitchen/requests/item-requests/sent/:id',
  KITCHEN_MANAGE_ITEM_COMPLETED: '/kitchen/requests/item-requests/completed/:id',
  KITCHEN_REVIEW_ITEM_REQUESTS_DETAILS: '/kitchen/requests/item-requests/review/:id',
  KITCHEN_MANAGE_PREP_ITEM_REQUESTS_DETAILS: '/kitchen/requests/prep-team-requests/:id',
  KITCHEN_REVIEW_PREP_ITEM_REQUESTS_DETAILS: '/kitchen/requests/prep-team-requests/review/:id',
  KITCHEN_ITEM_REQUESTS_DETAILS: '/main-store/requests/item-requests/:id/review',
  KITCHEN_MANAGE_EXCESS_RETURNS: '/kitchen/requests/excess-returns',
  KITCHEN_MANAGE_EXCESS_RETURNS_DETAILS: ':id',

  // procurement
  KITCHEN_PROCUREMENT: '/kitchen/procurement',
  KITCHEN_NEW_PROCUREMENT: 'new',
  KITCHEN_PROCUREMENT_LIST: 'list',
  KITCHEN_PROCUREMENT_TEST: 'test',
  KITCHEN_PROCUREMENT_UPDATE: 'update/:id',
  KITCHEN_PROCUREMENT_DETAILS_UPDATE: 'update-details/:id',
  KITCHEN_PROCUREMENT_UPDATE_REJECTED: 'update-rejected/:id',

  KITCHEN_WASTE_REPORT: '/kitchen/waste-report',

  // PRODUCTION REPORT
  KITCHEN_PRODUCTION_REPORT: '/kitchen/production-report',
  KITCHEN_EDIT_COKITCHEN_ITEM: '/kitchen/production-report/edit',
  KITCHEN_ADD_MEAL: '/kitchen/production-report/add-meal',
  KITCHEN_REVIEW_MEAL: '/kitchen/production-report/review-meal',
  KITCHEN_UPDATE_PORTIONS: 'update-portions',

  //SETTINGS
  MANAGE_ROLES: '/settings/manage-role',
  MANAGE_USERS: '/settings/manage-users',
  MANAGE_USERS_ADD_USERS: 'add',
  MANAGE_USERS_EDIT_USERS: 'edit',

  //EXECUTIVE
  EXECUTIVE_PROCUREMENTS: '/executive/procurements',
  EXECUTIVE_UPDATE_PROCUREMENT: ':id',

  // PREP_TEAM
  PREP_TEAM: '/prep-team',
  PREP_REQUEST_REPORT: '/prep-team/prep-team-requests/report/:id',

  CONVERSION_LIST_PREP_TEAM: 'prep-team/conversion-list',
  PREP_REQUESTS: '/prep-team/prep-team-requests',
  KITCHEN_MANAGE_PREP_TEAM_REQUESTS: '/kitchen/request/prep-team',
  RECEIVE_PREP_ITEMS: 'receive-items/:id',
  COMPLETE_PREP_REQUEST: 'completed/:id',

  // GENERAL
  GENERAL_STORE_DASHBOARD: '/general-store',
  STORE_BY_ID: '/general-store/:storeSubRoute',
  PROFILE: '/profile',

  // MINIMUM STOCK SETTINGS
  MAIN_STORE_MINIMUM_STOCK_SETTINGS: '/main-store/minimum-stock-settings',
  KITCHEN_MINIMUM_STOCK_SETTINGS: '/kitchen/minimum-stock-settings',

  //v2
  MAIN_STORE_REQUEST_RETURN_ITEMS: '/main-store/requests/item-requests/return-items/:ids',
  MAIN_STORE_REQUEST_RECEIVE_ITEMS: '/main-store/requests/item-requests/receive-items/:ids',

  PROCUREMENT_REQUEST_RETURN_ITEMS: '/main-store/procurement/update/return-items/:ids',
  PROCUREMENT_REQUEST_RECEIVE_ITEMS: '/main-store/procurement/update/receive-items/:ids'
};

export const STORAGE_KEYS = {
  ...AUTH_STORAGE_KEYS,
  COKITCHEN_LIST: 'cokitchen_list',
  ADMIN_ROLE: 'admin-role',
  ACTIVE_STORE: 'active_store',
  ROLE_PERMISSIONS: 'role_permissions'
};

export const TRANSFER_STATUS_TAG: Record<ENUM_TRANSFER_STATUS, any> = {
  REQUESTED: {
    text: 'requested',
    bgColor: '#FEF7E1',
    textColor: '#C69706'
  }, // yellow'
  ALL: {
    text: 'requested',
    bgColor: '#FEF7E1',
    textColor: '#C69706'
  }, // yellow
  RECEIVED: {
    text: 'received',
    bgColor: '#E0F2FF',
    textColor: '#0080E5'
  }, // yellow
  SENT: {
    text: 'sent',
    bgColor: '#EEF9EB',
    textColor: '#46AE31'
  }, // yellow
  REJECTED: {
    text: 'rejected',
    bgColor: '#FEF0F2',
    textColor: '#E60A2B'
  } //red
};

export const PROCUREMENT_STATUS_TAG: Record<ENUM_PROCUREMENT_STATUS, any> = {
  CREATED: {
    text: 'created',
    bgColor: '#FEF7E1',
    textColor: '#C69706'
  }, // yellow
  REQUESTED: {
    text: 'requested',
    bgColor: '#FEF7E1',
    textColor: '#C69706'
  }, // yellow
  APPROVED: {
    text: 'approved',
    bgColor: '#E0F2FF',
    textColor: '#0080E5'
  }, // blue
  COMPLETED: {
    text: 'completed',
    bgColor: '#E0F2FF',
    textColor: '#0080E5'
  }, // blue
  RECEIVED: {
    text: 'received',
    bgColor: '#EEF9EB',
    textColor: '#46AE31'
  }, //green
  PAID: {
    text: 'paid',
    bgColor: '#EEF9EB',
    textColor: '#46AE31'
  }, //green
  REJECTED: {
    text: 'rejected',
    bgColor: '#FEF0F2',
    textColor: '#E60A2B'
  }, //red
  CANCELLED: {
    text: 'cancelled',
    bgColor: '#FEF0F2',
    textColor: '#E60A2B'
  }, //red
  PENDING: {
    text: 'pending',
    bgColor: '#F2F2F3',
    textColor: '#6F7376'
  }, //grey
  RETURNED: {
    text: 'returned',
    bgColor: '#FEF0F2',
    textColor: '#E60A2B'
  }, //red
  REVIEWED: {
    text: 'reviewed',
    bgColor: '#FEF7E1',
    textColor: '#C69706'
  }, //yellow
  SENT: {
    text: 'Sent',
    bgColor: '#EEF9EB',
    textColor: '#46AE31'
  },
  OPEN: {
    text: 'open',
    bgColor: '#FEF7E1',
    textColor: '#C69706'
  }
};

export const REQUEST_STATUS_TAG: Record<ENUM_REQUEST_STATUS, any> = {
  [ENUM_REQUEST_STATUS.SENT]: {
    text: 'sent',
    bgColor: '#E0F2FF',
    textColor: '#0080E5'
  }, // blue
  [ENUM_REQUEST_STATUS.APPROVED]: {
    text: 'sent',
    bgColor: '#E0F2FF',
    textColor: '#0080E5'
  }, // blue
  [ENUM_REQUEST_STATUS.COMPLETED]: {
    text: '',
    bgColor: '#EEF9EB',
    textColor: '#46AE31'
  }, //green
  [ENUM_REQUEST_STATUS.REJECTED]: {
    text: 'rejected',
    bgColor: '#FEF0F2',
    textColor: '#E60A2B'
  }, //red
  [ENUM_REQUEST_STATUS.PENDING]: {
    text: 'pending',
    bgColor: '#F2F2F3',
    textColor: '#6F7376'
  }, //grey
  [ENUM_REQUEST_STATUS.CREATED]: {
    text: 'created',
    bgColor: '#F2F2F3',
    textColor: '#6F7376'
  }, //grey
  [ENUM_REQUEST_STATUS.REQUESTED]: {
    text: 'requested',
    bgColor: '#FFF2E0',
    textColor: '#FF9500'
  }, //yellow
  [ENUM_REQUEST_STATUS.RECEIVED]: {
    text: 'received',
    bgColor: '#EEF9EB',
    textColor: '#46AE31'
  }, //green,
  [ENUM_REQUEST_STATUS.REVIEWED]: {
    text: 'reviewed',
    bgColor: '',
    textColor: '#000000'
  },
  [ENUM_REQUEST_STATUS.RETURNED]: {
    text: 'returned',
    bgColor: '#FEF0F2',
    textColor: '#E60A2B'
  },
  [ENUM_REQUEST_STATUS.PAID]: {
    text: 'paid',
    bgColor: '#EEF9EB',
    textColor: '#46AE31'
  },
  [ENUM_REQUEST_STATUS.CANCELLED]: {
    text: 'cancelled',
    bgColor: '#FEF0F2',
    textColor: '#E60A2B'
  },
  [ENUM_REQUEST_STATUS.OPEN]: {
    text: 'open',
    bgColor: '#FEF7E1',
    textColor: '#C69706'
  }
};

export const PAYMENT_STATUS_TAG: Record<ENUM_PAYMENT_STATUS, any> = {
  [ENUM_PAYMENT_STATUS.APPROVED]: {
    text: 'approved',
    bgColor: '#E0F2FF',
    textColor: '#0080E5'
  }, // blue
  [ENUM_PAYMENT_STATUS.COMPLETED]: {
    text: '',
    bgColor: '#EEF9EB',
    textColor: '#46AE31'
  }, //green
  [ENUM_PAYMENT_STATUS.REJECTED]: {
    text: 'rejected',
    bgColor: '#FEF0F2',
    textColor: '#E60A2B'
  }, //red
  [ENUM_PAYMENT_STATUS.PENDING]: {
    text: 'pending',
    bgColor: '#FFF2E0',
    textColor: '#FF9500'
  }, //yellow
  [ENUM_PAYMENT_STATUS.OUTSTANDING]: {
    text: 'created',
    bgColor: '#F2F2F3',
    textColor: '#6F7376'
  }, //grey
  [ENUM_PAYMENT_STATUS.REQUESTED]: {
    text: 'requested',
    bgColor: '#FFF2E0',
    textColor: '#FF9500'
  },
  [ENUM_PAYMENT_STATUS.PAID]: {
    text: 'paid',
    bgColor: '#EEF9EB',
    textColor: '#46AE31'
  }
};

export const MEAL_STATUS_TAG: Record<ENUM_MEAL_STATUS, any> = {
  [ENUM_MEAL_STATUS.AVAILABLE]: {
    text: 'Available',
    textColor: '#3FB827'
  }, // green
  [ENUM_MEAL_STATUS.SOLD_OUT]: {
    text: 'Sold out',
    textColor: '#E60A2B'
  } // green
};

export const DEFAULT_TAG = {
  text: '',
  bgColor: '#FFFFFF',
  textColor: '#000000'
};
export const RETURNS_STATUS_TAG: Record<ENUM_RETURNS_STATUS, any> = {
  CREATED: {
    text: 'Created',
    bgColor: '#FFF2E0',
    textColor: '#FF9500'
  }, //yellow
  COMPLETED: {
    text: 'Completed',
    bgColor: '#EEF9EB',
    textColor: '#46AE31'
  } //green
};

export const weightMeasurement = [
  { name: 'Kilogram (Kg)', value: ENUM_UNIT.KG },
  { name: 'Gram (g)', value: ENUM_UNIT.G },
  { name: 'Unit', value: ENUM_UNIT.UNIT }
];
export const storeItemWeightMeasurement = [
  { name: 'Grams', value: ENUM_UNIT.GRAM },
  { name: 'Units', value: ENUM_UNIT.UNIT },
  { name: 'Portions', value: ENUM_UNIT.PORTION },
  { name: 'pcs', value: ENUM_UNIT.PCS },

  { name: 'Packs', value: ENUM_UNIT.PACK }
];

export const ALL = 'ALL';
export const BELOW = 'BELOW';
export const ABOVE = 'ABOVE';
export const FILE_UPLOADER_TOKEN = process.env.REACT_APP_FILE_UPLOADER_TOKEN || '';

export const DefaultTransferDetails = {
  cokitchen: {} as CoKitchenType,
  store: {} as StoreType,
  title: '',
  note: '',
  storeType: { name: '', id: '' }
};

export const DefaultTransfer: TransferRequestType = {
  name: '',
  id: '',
  code: 0,
  store_id: '',
  from_store_id: '',
  transfer_type: '',
  request_index: '',
  status: ENUM_TRANSFER_STATUS.REQUESTED,
  created_at: '',
  updated_at: '',
  items: []
};
